import './App.css';
import { Navbar } from './component/Navbar';

function App() {
  return (
    <div className="App">
      <Navbar/>
    </div>
  );  
}
export default App;


